import React, { useMemo } from "react";
import { Breadcrumb, BreadcrumbNavigator } from "cm-layout";
import _ from "lodash";
import { isPhone } from "@cadmakers-ui/core";
import { useHistory } from "react-router-dom";
import { useBreadcrumbs } from "../../Hooks/useBreadcrumbs";
import { appPaths } from "../../../Common";

export const Breadcrumbs = () => {
  const { items } = useBreadcrumbs();
  const mappedItems = useMemo(() => {
    return items.map((item, index) => ({
      key: item.key,
      path: item.linkPath,
      text: item.name,
      active: index === items.length - 1
    }));
  }, [items]);

  const history = useHistory();

  const onBackClick = () => {
    let path = "";

    const reversedItems = items.reverse().filter(i => !!i.linkPath);

    if (reversedItems.length <= 1) {
      path = appPaths.root;
    } else {
      path = reversedItems[1].linkPath ? items[items.length - 2].linkPath : appPaths.root;

      if (path === "#") {
        path = appPaths.root;
      }
    }
    history.push(path);
  };

  if (!isPhone) {
    return <Breadcrumb items={mappedItems} />;
  }

  return <BreadcrumbNavigator items={mappedItems} onBackClick={onBackClick} />;
};
